<template>
<div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

  <v-data-table
    :headers="headers"
    :items="district_super_master_list"
    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>District</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add District</v-btn>
            <v-btn class="mb-2 mr-2" rounded color="success" small tile @click="openFileSelector()">
              <v-icon class="mr-2" small>mdi-file-import</v-icon>import District
            </v-btn>
          </template>
          <v-card>
            <v-form v-model="valid">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.district_super_master" 
                    persistent-hint
                    label="Enter District"
                    :rules="[v => !!v || 'required']"
                    >
                    </v-text-field>
                  </v-col>
                   
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field label="Enter District In Unicode" v-model="editedItem.unicode_district_name"></v-text-field>
                  </v-col>
                </v-row>
               
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="primary darken-1"  @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
    </template>
  </v-data-table>
  
  <v-dialog v-model="import_dialog" max-width="500px">
  <v-card>
    <v-card-title>
      <span class="headline mb-5">Import District</span>
       <v-spacer></v-spacer>
       <v-btn small color="success" @click="generateExcel" class="mb-5">
      Download Excel Template
    </v-btn>
    </v-card-title>

    <v-card-text>
      <v-file-input
        v-model="file"
        label="Select district CSV File"
        prepend-icon="mdi-file"
        outlined
        rounded
        dense
        show-size
      ></v-file-input>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
      <v-btn color="primary darken-1" @click="importDistrict" :disabled="!file">Submit</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
  export default {
    data: () => ({
      valid: false,
      overlay: false,
    errorMsg: {
      districtId: false
    },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      file:null,
      import_dialog:false,
      dialog: false,
      headers: [
        {
          text: 'District',
          align: 'left',
          sortable: false,
          value: 'district_super_master',
        },
        {
          text: 'District In Unicode',
          align: 'left',
          sortable: false,
          value: 'unicode_district_name',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      fieldNames: ["District Name", "District In Unicode"],
      district_super_master_list: [],
      editedIndex: -1,
      editedItem: {
        districtId: "",
        district_super_master:"",
        unicode_district_name:"",
      },
      defaultItem: {
        districtId: "",
        district_super_master: "",
        unicode_district_name:"",
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New District' : 'Edit District'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val= () => {
          this.overlay = false
        };
      },
    },

    mounted(){
       this.onLoad()
     },
    methods: {
   
    onLoad(){
      this.overlay=true;
          axios
      .post("/Admin/adminDistrict")
      .then(res => {
        if (res.data.msg == "200") {
          if(this.load = true){
            this.overlay=false;
            this.district_super_master_list = res.data.district_super_master_list;
          }
        } 
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); 
        window.console.log(error);
      })
      .finally(()=>{ 
        var overlay=false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem (item) {
        this.editedIndex = this.district_super_master_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
    },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save() {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/Admin/editAdminDistrict", this.editedItem)
              .then(res => {
                if (res.data.status === "SUCCESS") {
                  Object.assign(
                    this.district_super_master_list[this.editedIndex],
                    this.editedItem
                  );
                  this.showSnackbar("#4caf50","District Updated Successfully...");
                  this.onLoad() 
                }
                 else if (res.data.status === "DUPLICATE") {
                  this.showSnackbar("#b71c1c", "District Already Present!!!");
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close();
          }
        } else {
            axios
              .post("/Admin/saveAdminDistrict", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {
                  this.district_super_master_list.push(this.editedItem);
                  this.showSnackbar("#4caf50", "District Added Successfully...");
                  this.onLoad()
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "District Already Present!!!"); 
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close();
        }
      }, 

      isValidated() {
        if (this.editedItem.district_super_master) {
          return true;
        } else {
          if (!this.editedItem.district_super_master) {
            this.errorMsg.district_super_master = true;
          }
          return false;
        }
      }, 
      openFileSelector() {
       this.import_dialog = true;
      },

      importDistrict() {

        if (!this.file) {
          this.showSnackbar("#b71c1c", "Please select a file!");
          return;
        }

        const formData = new FormData();
        formData.append("file", this.file);
        this.overlay = true;

        axios.post("/Admin/importDistrict", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "EPS-token": localStorage.getItem("EPS-token"),
            "EPS-uid": localStorage.getItem("EPS-uid"),
            "router-path": this.$route.path
          }
        })
        .then((res) => {
          if (res.data.status === "SUCCESS") {
            this.showSnackbar("#4caf50", res.data.snackbar);
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar || "Import Failed");
            this.onLoad();
          }
          this.import_dialog = false;
          this.file = null;
        })
        .catch((error) => {
          console.error("Import failed:", error);
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          this.overlay = false;
        });
      },

     generateExcel() {
        try {
          const dataForSheet = [this.fieldNames];
          const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import District");
          const wscols = this.fieldNames.map(() => ({ wch: 20 }));
          worksheet['!cols'] = wscols;
          XLSX.writeFile(workbook, "District_Import_Template.xlsx");
        } catch (error) {
          console.error("Error generating Excel:", error);
          alert("Failed to generate Excel file.");
        }
      },
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>